import React, { useState } from 'react';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { Button } from './Styles';
import '../css/Home.css'

const ScrollButton = () => {

    const [visible, setVisible] = useState(false)

    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 300) {
            setVisible(true)
        }
        else if (scrolled <= 300) {
            setVisible(false)
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
            /* you can also use 'auto' behaviour
                in place of 'smooth' */
        });
    };

    window.addEventListener('scroll', toggleVisible);

    return (
        <Button style={{ padding: '5px' }}>
            <ExpandLessIcon onClick={scrollToTop}
                style={{ display: visible ? 'inline' : 'none', backgroundColor: '#fb839e', borderRadius: '50%' }} />
        </Button>
    );
}

export default ScrollButton;
